import styled from 'styled-components'

export const PageTitleShell = styled.h1`
  margin: 0;
`

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
`

export const LoadingState = styled.div`
  padding: 3rem 0;
  text-align: center;
  color: ${({ theme }) => theme.grey700Color};
  font-size: 0.875rem;
`
